'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('quickbooks-list', {
      url: '/admin/list/quickbooks/:propertyId',
      template: '<quickbooks-list></quickbooks-list>',
      authenticate: 'suite-superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/app/import/quickbooks-list/quickbooks-list.routes.js